// EmailJS credentials
// Get them from https://dashboard.emailjs.com/admin
export const EMAILJS_CONFIG = {
  serviceId: "service_06cz65o",
  templateId: "template_padres",
  publicKey: "n7frEV6wEEFKffR_g"
};

// Template variables your EmailJS template should use:
// {{to_name}}    - Nombre del padre
// {{to_email}}   - Correo del padre
// {{subject}}    - Asunto del correo
// {{message}}    - Cuerpo del correo (HTML o texto)
// {{total_amount}} - Total de todas las facturas
// {{invoice_count}} - Cantidad de facturas
